// services/eventBus.js
import mitt from "mitt";   // npm install mitt
const eventBus = mitt();
export default eventBus;
